// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './vendor/bugherd'
import './vendor/typeface-montserrat'
import './vendor/font-awesome'
import './vendor/vue-clipboard2'

import Vue from 'vue'
import { createRouter } from './router'
import store from 'store'
import { sync } from 'vuex-router-sync'
import { i18n } from './i18n'
import { apolloProvider } from '@/graphql/apollo'

import './directives'

import App from './App'

store.dispatch('restoreCurrentUser')

const router = createRouter(store)

sync(store, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  apolloProvider,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js